import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { getProfileCertificates } from 'b2b-apps/shop/context/redux/selectors';
import { isCertified } from 'b2b-apps/shop/context/utils/certificates';

export type UseCertificationValidatorReturnType = (
  productCertificates: string[],
) => boolean;

export function useCertificationValidator(): UseCertificationValidatorReturnType {
  const debitorCertificates = useSelector(getProfileCertificates);

  return useCallback(
    (productCertificates) => isCertified(productCertificates, debitorCertificates),
    [debitorCertificates],
  );
}
